<script>
export default {
  name: "DidoMillesimeInputFilterWrapper",
};
</script>

<script setup>
import { ref, computed, watch } from "vue";
import DidoMillesimeInputFilterSimple from "./Simple.vue";
import DidoMillesimeInputFilterMultiple from "./Multiple.vue";
import DidoMillesimeInputFilterSelectInList from "./SelectInList.vue";
import DidoMillesimeInputFilterCog from "./Cog.vue";
import DidoMillesimeInputFilterGeometry from "./Geometry.vue";

// define Props
const props = defineProps({
  apiUrl: { type: String, required: true },
  filter: { type: String, required: false, default: "" },
  modelValue: { type: String, required: false, default: "" },
  availableValues: { type: Array, required: false, default: null },
  label: { type: Boolean, required: false, default: true },
  type: { type: String, required: false, default: "" },
});

// define Emits
const emit = defineEmits(["update:model-value"]);

// define reactive data
const inputValue = ref(props.modelValue);

// define computed data
const inputType = computed(() => {
  if (
    [
      "eq",
      "ne",
      "gt",
      "gte",
      "lt",
      "lte",
      "startsWith",
      "endsWith",
      "contains",
    ].includes(props.filter)
  )
    return "simpleInput";
  if (props.filter === "valuesList") return "selectInList";
  if (["in", "nin"].includes(props.filter)) {
    if (props.availableValues && props.availableValues.length)
      return "selectInList";
    return "multipleInput";
  }
  if (props.filter === "withinCogZones") return "selectCog";
  if (props.filter === "withinGeometry") return "inputOrDrawGeoJson";
  return "";
});

// define watchers
watch(
  () => [props.filter, props.modelValue],
  () => (inputValue.value = props.modelValue),
);
</script>

<template>
  <div>
    <div v-if="inputType === 'simpleInput'">
      <DidoMillesimeInputFilterSimple
        v-model="inputValue"
        :label="props.label"
        :type="props.type"
        @update:model-value="emit('update:model-value', inputValue)"
      />
    </div>
    <div v-if="inputType === 'multipleInput'">
      <DidoMillesimeInputFilterMultiple
        v-model="inputValue"
        :label="props.label"
        :type="props.type"
        @update:model-value="emit('update:model-value', inputValue)"
      />
    </div>
    <div v-if="inputType === 'selectInList'">
      <DidoMillesimeInputFilterSelectInList
        v-model="inputValue"
        :available-values="props.availableValues"
        :label="props.label"
        :type="props.type"
        @update:model-value="emit('update:model-value', inputValue)"
      />
    </div>
    <div v-if="inputType === 'selectCog'">
      <DidoMillesimeInputFilterCog
        v-model="inputValue"
        :api-url="props.apiUrl"
        :label="props.label"
        @update:model-value="emit('update:model-value', inputValue)"
      />
    </div>
    <div v-if="inputType === 'inputOrDrawGeoJson'">
      <DidoMillesimeInputFilterGeometry
        v-model="inputValue"
        :label="props.label"
        @update:model-value="emit('update:model-value', inputValue)"
      />
    </div>
  </div>
</template>
